import React, { useEffect, useState, useRef } from "react";
import ReactHtmlParser from "react-html-parser";
import AssignmentStatus from "../../course/AssignmentStatus";
import AssignmentType from "../../course/AssignmentType";
import Str from "../../common/Str";
// import Exam_recording from "../../../pages/object-detection/Exam_recording";
// import '../../../pages/object-detection/styles.css';
import { SystemIcons } from "../../common/SystemIcons";
import { SysCheckSideIcon } from "../../common/SysCheckSideIcon";
// import AudioDetection from "../../../pages/object-detection/audio-detection";
import Swal from "sweetalert2";
import QuizDescription from "../quiz/QuizDescriptionExam";
import ViewQuiz from "../quiz/ViewQuiz";
import { GetQuizByIdService, GetQuizQuestionsService, InsertAttemptedQuestions } from "../../../services/QuizService";
import { useDispatch, useSelector } from "react-redux";
import { clearQuiz, setIsExamLaunched, setQuizComplete } from "../../../store/actions";
import AssessmentDetailTab from "./AssessmentDetailTab";
import { StoreTime } from "../../../services/QualificationService";
import { Link, useHistory } from "react-router-dom";
import { getRandomInt } from "../../../utils/commonFunction";
import { useParams } from "react-router-dom";
import { ContainerWrapper } from "../../common/GlobalElements/Wrappers";
import { StandardButton } from "../../common/GlobalElements/StandardButton";
import { Heading2 } from "../../common/GlobalElements/Typography";
import { tokens } from "../../../public/tokens";
import { invalidateSignatureQa, mergeSignatureQa } from "../../../utils/signatureQaStorage";

const Step4 = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { examLaunched } = useSelector(state=>state.examLaunched);
  const isExamLaunched = history.location.pathname === examLaunched?.url && examLaunched?.isExamLaunched;

  const hasLaunchedRef = useRef(false);
  const hasLaunchedRefViaExam = useRef(false);
  const isMounted = useRef(true);
  const { quiz } = useSelector(state => state.quiz);
  const quizData = Object.values(quiz)
  const {sid} = useParams();


  const setSoundCounts = (data) => {
    props.soundCount(data)
  }

  useEffect(() => {
    isMounted.current = true;
    localStorage.removeItem("totaltime");
    if(props.quizId){
      GetQuizByIdService({ qid: props.quizId })
        .then((res) => {
          props.setquiz(res.data[0]);
          props.setresult(res.data[1]);
        })
        .catch((err) => console.log(err));
    }

    return () => {
      isMounted.current = false;
      props.setquiz("");
    }
  }, []);

  const launchExam = (isLaunched) => {
    if (!isMounted.current) return; 
    setLoading(true);
    if (props.quizId && !isLaunched) {
      Swal.close();
      Swal.fire({
        title: 'Are you sure?',
        text: Str.quizPopup,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Launch',
      }).then(function (result) {
        if (result.value) {
          // props.setStep(5)
          Swal.close()
          props.setIsExamLaunchedToTrue()

          GetQuizQuestionsService({ quid: props.quizId, assignment_id: props.assessmentId,intake_id: sid })
            .then((res) => {
              if (!isMounted.current) return;
              try {
                if (Object.values(res.data?.signatures || {})?.length != 0) {
                  mergeSignatureQa(res.data?.signatures);
                } else {
                  invalidateSignatureQa();
                }
              } catch (error) {
                console.log(error)
              }
              // setquiz(res.data);
              if (!isMounted.current) return;
              dispatch(clearQuiz());
              props.setResetCount(getRandomInt(5000))
              try {
                props.setSoundCount(0);
                props.setCameraObj({});
                props.setSwitchAway(0);
                localStorage.removeItem("Monitoring Object" + props.assessmentId)
              } catch (err) {
                console.log("removed Objecterr", err)
              }
              // dispatch(setQuizComplete(res.data.reduxData));
              const obj = {};
              const allQuizId = [];
              res.data.questions.filter(list=>(list && list.questions && list.questions.length > 0)).map(q=>{
                if(q.type === 0){
                  obj[`qa${q.questions[0].qid}qa`] = q.questions[0]
                  allQuizId.push(q.questions[0].qid);
                } else {
                  obj[`qa${q.questions[0].qid}qa`] = q.questions
                  allQuizId.push(q.questions.map(q=>q.qid));
                }
              })
              // console.log("_______________ Attempts Left _____",(res?.data?.description?.maximum_attempts - res?.data?.totalattempt));
              // console.log("_________ obj>>>>>",Object.values(obj).map(ques=>ques?.qid).join(","));
             
              props.setMaxAttempt(res.data.description.maximum_attempts);
              localStorage.removeItem("totaltime");
              for (let i = 0; i < localStorage.length; i++) {
                let value = localStorage.key(i);
                if (value.startsWith("@")) {
                  localStorage.removeItem(value);
                }
              }
              for (let i = 0; i < localStorage.length; i++) {
                let value = localStorage.key(i);
                if (value.startsWith("@")) {
                  localStorage.removeItem(value);
                }
              }

              res.data.questions.filter(list=>(list && list.questions && list.questions.length > 0)).map(q => {
                q.questions.map(ques=>{
                    localStorage.setItem(`@qa${ques.qid}qa`, 0);
                })
              })
              // const keys = Object.keys(res.data.reduxData);
              // const keys = Object.keys(obj);
              // keys.map((item, index) => {
              //   // localStorage.setItem("@" + item, index == 0 ? 1 : 0);
              //   localStorage.setItem(
              //     "@" + item,
              //     res.data.individual_time[index] || 0
              //   );
              // });
              dispatch(setQuizComplete(obj));
              setLoading(false);
              props.setshow({ question: true });
              props.setStep(5)

              let quizanswer = [];
              let timearr = [];

              const getAnswerItem = (item) =>{
                // console.log("item.question_type>>>>>>>>>>>>", item.question_type)
                const answerItemList = []
                // Multiple Choice Multiple Answer && Multiple Choice Single Answer && Choice Matrix && Fill In The Blank && Document Upload
                if (item.question_type == "Multiple Choice Single Answer" || item.question_type == "Multiple Choice Multiple Answer" || item.question_type == "Choice Matrix" || item.question_type == "Fill in the blank" || item.question_type === "Document Upload" || item.question_type === "Evidence Only") {
                  answerItemList.push({
                    aid: 0,
                    qid: item.qid,
                    q_option: item.selected,
                    // score: item.score,
                    docs: null,
                    type: item.question_type,
                  });
                }
            
                // Match the Column && Order List
                if (item.question_type == "Match the Column" || item.question_type == "Order List") {
                  answerItemList.push({
                    aid: 0,
                    qid: item.qid,
                    q_option: {choice: item.choice, selectedItems: item.selectedItems, selected: item.selected},
                    // score: item.score,
                    docs: null,
                    type: item.question_type,
                  });
                } 
            
                // Long Answer && Short Answer
                if (item.question_type == "Long Answer" || item.question_type == "Short Answer") {
                  answerItemList.push({
                    aid: 0,
                    qid: item.qid,
                    q_option: (Array.isArray(item?.selected) && item?.selected.length) ? item?.selected[0]?.q_option.toString().trim() : item.selected.toString().trim(),
                    // score: item.score,
                    docs: null,
                    type: item.question_type,
                  });
                }
            
                return answerItemList;
              }
              if (obj) {
                let dataofQuiz = Object.values(obj)
                if (dataofQuiz?.length) {
                  dataofQuiz.map((item) => {
                    if (item.question_type) {
                      quizanswer = [...quizanswer, ...getAnswerItem(item)]
                      timearr.push(localStorage.getItem(`@qa${item?.qid}qa`));
                    } else if (Array.isArray(item) && item.length) {
                      item.map((subItem) => {
                        quizanswer = [...quizanswer, ...getAnswerItem(subItem)]
                        timearr.push(localStorage.getItem(`@qa${subItem?.qid}qa`));
                      })
                    }
                  });
                }
              }
              const body = {
                assessment_id: Number(props?.assessmentId),
                attempt_no : parseInt(res.data?.totalattempt) + 1,
                quizanswer,
                quid: props.quizId,
              }
              InsertAttemptedQuestions(body)
              .then((res) => {console.log(res)})
              .catch((err) => {
                console.log("Step4 -> insertAttemptedQuestions -> Error",err);
              })

              StoreTime({ assId: props?.assessmentId, attempted_no: (res?.data?.description?.maximum_attempts - res?.data?.totalattempt) ,questions_order: allQuizId.join(",") })
                .then((res) => {
                  // console.log("STORE TIME:", res);
                  props.setAssignmentReload();
                })
                .catch((error) => {
                  console.error(error);
                });
            })
            .catch((err) => {
              if(isMounted.current){
              setLoading(false);
              console.log(err);
              }
            });
        }
      }).finally(()=>{
        setLoading(false);
      });
    }
    else {
      if (!isMounted.current) return; 
      // props.launchDownload()
      GetQuizQuestionsService({ quid: props.quizId, assignment_id: props.assessmentId, intake_id: sid })
        .then((res) => {
          if (!isMounted.current) return; 
          try {
            if (Object.values(res.data?.signatures || {})?.length != 0) {
              mergeSignatureQa(res.data?.signatures);
            } else {
              invalidateSignatureQa();
            }
          } catch (error) {
            console.log(error)
          }
          // setquiz(res.data);
          dispatch(clearQuiz());
          // dispatch(setQuizComplete(res.data.reduxData));
          const obj = {};
          res.data.questions.filter(list => (list && list.questions && list.questions.length > 0)).map(q => {
            if (q.type === 0) {
              obj[`qa${q.questions[0].qid}qa`] = q.questions[0]
            } else {
              obj[`qa${q.questions[0].qid}qa`] = q.questions
            }
          })
          // console.log("_______________ Attempts Left _____",(res?.data?.description?.maximum_attempts - res?.data?.totalattempt));
          // console.log("_________ obj>>>>>",Object.values(obj).map(ques=>ques?.qid).join(","));

          props.setMaxAttempt(res.data.description.maximum_attempts);
          localStorage.removeItem("totaltime");
          for (let i = 0; i < localStorage.length; i++) {
            let value = localStorage.key(i);
            if (value.startsWith("@")) {
              localStorage.removeItem(value);
            }
          }
          for (let i = 0; i < localStorage.length; i++) {
            let value = localStorage.key(i);
            if (value.startsWith("@")) {
              localStorage.removeItem(value);
            }
          }

          res.data.questions.filter(list => (list && list.questions && list.questions.length > 0)).map(q => {
            q.questions.map(ques => {
              localStorage.setItem(`@qa${ques.qid}qa`, 0);
            })
          })
          // const keys = Object.keys(res.data.reduxData);
          // const keys = Object.keys(obj);
          // keys.map((item, index) => {
          //   // localStorage.setItem("@" + item, index == 0 ? 1 : 0);
          //   localStorage.setItem(
          //     "@" + item,
          //     res.data.individual_time[index] || 0
          //   );
          // });
          dispatch(setQuizComplete(obj));
          setLoading(false);
          props.setshow({ question: true });
          props.setStep(5)

          StoreTime({ assId: props?.assessmentId, attempted_no: (res?.data?.description?.maximum_attempts - res?.data?.totalattempt), questions_order: Object.values(obj).map(ques => ques?.qid).join(",") })
            .then((res) => {
              // console.log("STORE TIME:", res);
            })
            .catch((error) => {
              console.error(error);
            });
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        }).finally(()=>{
          setLoading(false);
        });
      // props.launchDownload({isLaunchedAndDownload: true, isOnlyDownload: false})
    }
  }

  useEffect(()=>{
    // console.log("____________________________ step 4",isExamLaunched,props.data.remainingDuration)
    if(isExamLaunched && Number(props.data.remainingDuration) > 0 && !hasLaunchedRef.current){
      launchExam(true);
      hasLaunchedRefViaExam.current = true;
    }

    if (props.data.launched && !hasLaunchedRef.current) {
      launchExam(true);
      hasLaunchedRef.current = true; // Mark as executed to prevent re-execution
    }
  },[examLaunched,props.data])

  const calculateTimeLeft = (close_time) => {
    const now = new Date().getTime();
    const closeTime = new Date(close_time).getTime();
    const timeLeft = closeTime - now;

    if (timeLeft <= 0) {
      return null;
    }

    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  return (
    <>
      <div className="tab-pane fade show active" id="Assessment-Detail">
        <div className="test-series-main-block">
          <div className="test-series-main-left-blk">
            <div className="test-series-main-heading icon-add mb-15">
              <Heading2 fontWeight={tokens.typography.fontWeights.semibold}>{props.data && props.data.name ? props.data.name : ""}{props.data && props.data.code ? ` (${props.data.code})` : ""}</Heading2>
              <span className="test-series-main-left-heading-act">
                <SystemIcons data={props.data} />
              </span>
            </div>
            <div className="breadcrumb-btn-blk">
              <div className="custom-breadcrumb">
                <StandardButton variant="transparent"  noAction= {true} as="ul">
                  <li onClick={() => {props.stepUpdate(1)}} className="custom-breadcrumb-item active">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>
                      <i className="fal fa-home"></i>
                    </a>
                  </li>
                  {props.showSystemCheck &&
                    <li onClick={() => {props.stepUpdate(2)}} className="custom-breadcrumb-item active">
                      <a href="#" onClick={(e)=>{e.preventDefault()}}>System Check</a>
                    </li>
                  }
                  {props.showIdentification &&
                    <li onClick={() => {props.stepUpdate(3)}} className="custom-breadcrumb-item active">
                      <a href="#" onClick={(e)=>{e.preventDefault()}}>Student Identification</a>
                    </li>
                  }
                  <li className="custom-breadcrumb-item inactive">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>Test</a>
                  </li>
                </StandardButton>
              </div>
              <div className="breadcrumb-btns">
                <StandardButton variant="primary" onClick={()=>props.backBtn()} type="button">
                  <i className="fal fa-chevron-left"></i> Back
                </StandardButton>
                <div className="breadcrumb-right-btns">
                  {calculateTimeLeft(props?.data?.close_date_time) ? (props.data.quiz_id == 0 && props.data.launched == 0) ? 
                    props.data.assFile != '' ?                     
                      <StandardButton 
                        variant="primary"
                        type="button"
                        disabled={props?.loader==true}
                        onClick={()=>{props.launchDownload({isLaunchedAndDownload: true, isOnlyDownload: false})}}
                      >
                        {props?.loader==true ?  <i className={`fas fa-cog fa-spin`}></i>  : <i className="fal fa-download"></i>}&nbsp; Launch & Download
                      </StandardButton>                    
                    : <StandardButton
                        variant="primary"
                        type="button"
                        disabled={props?.loader==true}
                        onClick={()=>{props.launchDownload({isLaunchedAndDownload: false, isOnlyDownload: false})}}
                      >
                        {props?.loader==true ?  <i className={`fas fa-cog fa-spin`}></i>  : <i className="fal fa-rocket"></i>}Launch
                      </StandardButton>                    
                  : 
                      <StandardButton
                        variant="primary"
                        onClick={() => { launchExam(false) }}
                        type="button"
                        disabled={loading==true}
                      >
                        <i className={loading==true ? "fas fa-cog fa-spin" : (props.data.quiz_id ? "fal fa-rocket" : "fal fa-download")}></i>
                        Launch {!props.data.quiz_id && ' & Download'}
                      </StandardButton>
                    : null}
                  {props.data.quiz_id == 0 && props.data.launched == 1 && props.data.assFile != '' ?
                    <StandardButton
                      variant="primary"
                      type="button"
                      disabled={props?.loader==true}
                      onClick={()=>{props.launchDownload({isLaunchedAndDownload: false, isOnlyDownload: true})}}
                    >
                      {props?.loader==true ?  <i className={`fas fa-cog fa-spin`}></i>  : <i className="fal fa-download"></i>}&nbsp; Download
                    </StandardButton>
                  : null}
                </div>
              </div>
            </div>
            <div className="test-series-main-heading mb-15">
              <Heading2 fontWeight={tokens.typography.fontWeights.semibold}>Details</Heading2>
            </div>
            <AssessmentDetailTab data={props.data} quizId={props.quizId} maxAttempt={props.maxAttempt} step={4} />

            <ContainerWrapper className="textseries-content-blk desc-instruction-blk white-brd-blk mb-15">
              <h4>{Str.detailDes}:</h4>
              {props?.data?.details
                ? ReactHtmlParser(props.data.details)
                : Str.noInstruction}
            </ContainerWrapper>
          </div>

          <div className="test-series-main-right-blk">
            <div className="step-sidebar-space">
              <SysCheckSideIcon props={props} />
            </div>

            <div className="test-series-steps">
              <ul>
                <li className="test-series-steps-item active done">
                  <a href="#" onClick={(e)=>{e.preventDefault()}}>
                    <span>1</span> <b>Assessment Detail</b>
                  </a>
                </li>
                {props.showSystemCheck ?
                  <li className="test-series-steps-item active done">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>
                      <span>2</span> <b>System Check</b>
                    </a>
                  </li>
                  : null}
                {props.showIdentification ?
                  <li className="test-series-steps-item active done">
                    <a href="#" onClick={(e)=>{e.preventDefault()}}>
                      <span>{props.showSystemCheck ? 3 : 2}</span> <b>{Str.Identification}</b>
                    </a>
                  </li>
                  : null}
                <li className="test-series-steps-item active">
                  <a href="#" onClick={(e)=>{e.preventDefault()}}>
                    <span>{(props.showSystemCheck && props.showIdentification) ? 4 : (props.showSystemCheck || props.showIdentification) ? 3 : 2}</span> <b>{Str.launchExam}</b>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Step4;
